import type { Faq } from "@components/Faq.js";
import type { Tenant } from "@core/schema/Tenant.js";
import { getAccountingPath } from "@core/schema/paths/getAccountingPath.js";
import { getEcommercePath } from "@core/schema/paths/getEcommercePath.js";
import { getGastroPath } from "@core/schema/paths/getGastroPath.js";
import { getHRPath } from "@core/schema/paths/getHRPath.js";
import { getProductionPath } from "@core/schema/paths/getProductionPath.js";

export function getFaqsTransport(tenant: Tenant): Faq[] {
	return [
		{
			question: "Podnikáme v oblasti přepravy a chystáme se digitalizovat procesy. Musíme digitalizovat vše najednou?",
			answer:
				"Ne, je možné jít postupnými kroky. Často začínáme malým funkčním celkem, například zpřehledněním účetnictví nebo zefektivněním plánování práce pro řidiče.",
		},
		{
			question: "Jak spolupráce ve zkratce probíhá?",
			answer:
				"Začínáme úvodní konzultací, kde od vás zjistíme maximum informací. V další fázi navrhneme řešení a prototyp. Následuje vývoj, testování a ostré spuštění. Poté přichází provozní podpora a další rozvoj.",
		},
		{
			question: "Kolik vývoj na míru stojí?",
			answer: `Cena závisí na konkrétním zadání a rozsahu projektu. Například [${getEcommercePath(tenant)}][[e-commerce]] řešení začíná na 150 000 Kč, běžně se ale rozpočet pohybuje okolo 1 milionu Kč. Webové aplikace zpravidla startují na 250 000 Kč, přičemž nejčastější cenová hladina je kolem 500 000 Kč. Každou zakázku naceníme individuálně podle vašich potřeb.`,
		},
		{
			question: "Vyvíjíte software i pro jiná odvětví, než je přeprava?",
			answer: `Ano, máme zkušenosti s vývojem například pro [${getEcommercePath(tenant)}][[e-commerce]], [${getGastroPath(tenant)}][[HORECA]], [${getAccountingPath(tenant)}][[účetnictví]], [${getHRPath(tenant)}][[HR]], [${getProductionPath(tenant)}][[výrobu]] a řadu dalších odvětví.`,
		},
		{
			question: "Jak dlouho trvá digitalizace v oblasti přepravy?",
			answer:
				"Vždy záleží na rozsahu. Digitalizace/automatizace jednoho nebo dvou procesů může být hotová v řádu dnů až týdnů, rozsáhlejší práce zaberou více času (např. 2 měsíce).",
		},
	];
}
